module.exports = __webpack_public_path__ + "static/media/C_F03.3e47c573.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/C_F03.png
// module id = 99
// module chunks = 0